import * as React from 'react';
import { CustomPropsContext } from '../src/CustomPropsProvider.js';

function useCustomProps() {
    return React.useContext(CustomPropsContext);
}

export { useCustomProps };
//# sourceMappingURL=useCustomProps.js.map
